function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document
    .querySelectorAll("product-model")
    .forEach((model) => model.modelViewerUI?.pause());
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    if (/\[\w+\]/.test(key)) {
      const rgx = /\[(\w+)\]/g;
      const top = /^([^\[]+)/.exec(key)[0];
      const sub = rgx.exec(key)[1];
      if (!obj[top]) {
        obj[top] = {};
      }
      obj[top][sub] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");
    const summaryElements = this.querySelectorAll("summary");
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach((element) => {
      element.setAttribute("role", "button");
      element.setAttribute("aria-expanded", false);
      element.setAttribute("aria-controls", element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary"))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );

      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove("menu-opening");
      this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
        details.removeAttribute("open");
        details.classList.remove("menu-opening");
      });
      this.mainDetailsToggle
        .querySelector("summary")
        .setAttribute("aria-expanded", false);
      document.body.classList.remove(
        `overflow-hidden-${this.dataset.breakpoint}`
      );
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove("menu-opening");
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById("shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this)
    );
    this.addEventListener("click", (event) => {
      if (event.target.nodeName === "MODAL-DIALOG") this.hide();
    });
    this.addEventListener("keyup", () => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    this.querySelector(".template-popup")?.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");
    button?.addEventListener("click", () => {
      document.querySelector(this.getAttribute("data-modal"))?.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener(
      "click",
      this.loadContent.bind(this)
    );
  }

  loadContent() {
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      window.pauseAllMedia();
      this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      ).focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector("ul");
    this.sliderItems = this.querySelectorAll("li");
    this.pageCount = this.querySelector(".slider-counter--current");
    this.pageTotal = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(
      this.slider.clientWidth / sliderItemsToShow[0].clientWidth
    );
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute("disabled", true);
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute("disabled", true);
    } else {
      this.nextButton.removeAttribute("disabled");
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + this.sliderLastItem.clientWidth
        : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    if (!this.closest(".fly-out-product-card-container")) {
      this.addEventListener("change", this.onVariantChange);
    }
  }

  onVariantChange(e) {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);

    let currentVariantId = this.currentVariant.id;
    if (this.querySelectorAll(".addons-available-variant").length > 0) {
      addonsAvailableVariants(this);
      function addonsAvailableVariants(currVar) {
        let parents = currVar.closest(".product__info-container");
        let inputLabels = parents.querySelectorAll(
          ".addon--product-container .input-label[data-varid]"
        );
        inputLabels.forEach((label) => {
          label.classList.add("hidden");
        });

        let availableVariants = currVar.querySelectorAll(
          `.addons-variants-available-main .addons-variants-sub[variant-id="${currentVariantId}"] .addons-available-variant`
        );
        if (availableVariants.length == 0) {
          inputLabels.forEach((label) => {
            label.classList.remove("hidden");
          });
        }

        availableVariants.forEach(function (variant) {
          let availableVarId = variant.getAttribute("available-id");
          let matchingLabels = parents.querySelectorAll(
            `.addon--product-container .input-label[data-varid="${availableVarId}"]`
          );

          if (matchingLabels.length == 0) {
            parents
              .querySelectorAll(".product-form__variant-list")
              .forEach(function (variantList) {
                var inputLabels = variantList.querySelectorAll(".input-label");
                var hiddenLabels = variantList.querySelectorAll(
                  ".input-label.hidden"
                );
                if (inputLabels.length === hiddenLabels.length) {
                  hiddenLabels.forEach(function (label) {
                    label.classList.remove("hidden");
                  });
                }
              });
            return false;
          }

          matchingLabels.forEach((label) => {
            label.classList.remove("hidden");
          });

          parents
            .querySelectorAll(".product-form__variant-list")
            .forEach(function (variantList) {
              var inputLabels = variantList.querySelectorAll(".input-label");
              var hiddenLabels = variantList.querySelectorAll(
                ".input-label.hidden"
              );
              if (inputLabels.length === hiddenLabels.length) {
                hiddenLabels.forEach(function (label) {
                  label.classList.remove("hidden");
                });
              }
            });

          parents
            .querySelectorAll(
              ".addon--product-container .product__dropdown-item"
            )
            .forEach((item) => {
              const hiddenDiv = item.querySelector(".input-label.hidden");
              if (
                hiddenDiv &&
                hiddenDiv ===
                  item.querySelector(".input-label.hidden:first-child")
              ) {
                const nextLabel = hiddenDiv.nextElementSibling;
                if (nextLabel) {
                  const labelToClick = nextLabel.querySelector("label");
                  if (labelToClick) {
                    labelToClick.click();
                  }
                }
              } else {
                const firstLabel = item.querySelector(
                  ".product-form__variant-list .input-label label"
                );
                if (firstLabel) {
                  firstLabel.click();
                }
              }
            });
        });
      }
    } else {
      document
        .querySelectorAll(".addon--product-container .product__dropdown-item")
        .forEach(function (item) {
          item.querySelectorAll(".input-label").forEach(function (label) {
            label.classList.remove("hidden");
          });
        });
    }

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      if (!$(this).hasClass("no-media-switch")) {
        this.updateMedia(this.currentVariant);
        this.updateURL();
      }
      this.updateVariantInput();
      this.renderProductInfo();

      // Change active variant name
      const variantName = $(e.target).data("name");
      let id = $(e.target).data("id");

      console.log("checking here");
      if ($(`.product__shipping[data-id=${id}]`).text() !== "") {
        $(".product__shipping").hide();
        $(`.product__shipping[data-id=${id}]`).css("display", "inline-block");
      } else {
        $(".product__shipping").hide();
      }

      $(e.target)
        .closest(".product-form__variant-container")
        .find(".product-form__variant-active p")
        .text(variantName);
      $(e.target)
        .closest(".product-form__variant-container")
        .siblings(".form__label")
        .find(".product-form__variant-active p")
        .text(variantName);
    }
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      const checkedInput = Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      );
      return checkedInput ? checkedInput.value : null;
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia(newVariant) {
    // Main slider
    var $newImages = $('[data-variant-name="' + newVariant["option1"] + '"]');

    var slideshow = window.pdpSlider;
    var newSlides = [];

    var $thumbnails = $(".product__media-thumbnails");
    var newThumbs = [];

    var count = 1;

    $newImages.each(function (e, el) {
      var id = el.dataset.mediaId;
      var url = el.dataset.variantUrl;
      var title = el.dataset.variantName;

      var slide = `
        <li class="product__media-item swiper-slide" data-media-id="{{ section.id }}-${id}" data-slideid="${
        count - 1
      }">
          <div class="product__media media">
          <div class="aspect-ratio img-fill" style="max-width: 100%; width: 100%; --aspect-ratio: 100%">
            <img src="${url}" class="lazyload lazyload--blur" data-src="${url}" data-widths="[200,300,400,600,800,900,1000]" data-sizes="auto" alt="${title}" data-media-id="{{ image.id }}">
          </div>        
          </div>
        </li>`;

      newSlides.push(slide);

      if (url !== undefined || url !== "") {
        var addClass = count == 1 ? "active" : "";
        var thumb = `
          <div class="product__slider-thumbnail-item product__slider--thumbnail-item-${url} ${addClass}" data-media-id="{{ section.id }}-${id}" data-slideid="${
          count - 1
        }">
            <div class="aspect-ratio img-fill" style="max-width: 100%; width: 100%; --aspect-ratio: 1.0">
              <img src="${url}" class="lazyload lazyload--blur" data-src="${url}" data-widths="[200,300,400,600,800,900,1000]" data-sizes="auto" alt="Ivory"  data-media-id="{{ section.id }}-${id}" sizes="430px">
            </div>
          </div>
        `;

        newThumbs.push(thumb);
      }

      count++;
    });

    slideshow.removeAllSlides();
    slideshow.appendSlide(newSlides);
    slideshow.slideToLoop(0);

    $thumbnails.empty();
    $thumbnails.append(newThumbs);

    let $stackImages = $(".stack-image-wrapper.stack-image-main");
    $stackImages.empty();
    $stackImages.append(newSlides);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        document
          .getElementById(`price-${this.dataset.section}`)
          ?.classList.remove("visibility-hidden");
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", true);
      if (text) addButton.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButton.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    document
      .getElementById(`price-${this.dataset.section}`)
      ?.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      const checkedInput = Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      );
      return checkedInput ? checkedInput.value : null;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

// Product Card
class ProductCard extends HTMLElement {
  constructor() {
    super();

    // Swatch
    this.swatch = $(".card-information__swatch");
    this.swatch.off("click").click(this.handleSwatchClick.bind(this));
  }

  handleSwatchClick(e) {
    e.preventDefault();

    const variantUrl = $(e.currentTarget).data("variantUrl");
    const variantId = $(e.currentTarget).data("variantId");
    const imageUrl = $(e.currentTarget).data("imageUrl");
    const color = $(e.currentTarget).data("value");
    const variantDiscount = $(e.currentTarget).data("variantDiscount");
    $(e.currentTarget)
      .parent(".swatch-color")
      .find(".swatch-title")
      .text(color);

    if (imageUrl) {
      const productCard = e.currentTarget.closest("product-card");
      if (productCard) {
        const imageElement = productCard.querySelector(".card__inner img");
        if (imageElement) {
          imageElement.setAttribute("src", imageUrl);
          imageElement.setAttribute("srcset", imageUrl);
        }
      }
    }

    const productCard = e.currentTarget.closest("product-card");
    const discountElement = productCard.querySelector(
      ".product-tag p"
    );

    if (variantDiscount > 0) {
      if (productCard) {
        if (discountElement) {
          productCard.querySelector(".product-tag").classList.remove("hidden");
          const finalVariantDiscount = "$" + variantDiscount + " OFF";
          discountElement.innerHTML = finalVariantDiscount;
        }
      }
    } else {
      productCard.querySelector(".product-tag") &&
        productCard.querySelector(".product-tag").classList.add("hidden");

    }

    this.swapImage(e, imageUrl, color);
    this.changeActiveState(e, color);
    this.swapLinks(e, variantUrl, variantId);

    /* swatch change price change */
    /*
    let dataPrice = $(e.currentTarget).attr('data-price');
    let dataComparePrice = $(e.currentTarget).attr('data-compare-price');

    let html = '';
    if(dataPrice === undefined){
      dataPrice = '';
    }
    if(dataComparePrice === undefined){
      dataComparePrice = '';
    }

    html +=  `<span class="igPrice">${dataPrice}</span><span class="product-compare-price">${dataComparePrice}</span>`;
    $(e.currentTarget).parents('.card-information').find('.price').html(html);

    */

    // Get the current target element
    let currentTarget = e.currentTarget;

    // Get data attributes

    let dataPrice = currentTarget.getAttribute("data-price");
    let dataComparePrice = currentTarget.getAttribute("data-compare-price");
    let dataBabyList = currentTarget.getAttribute("data-babylist");

    // Set default values if attributes are undefined
    if (dataPrice === null) {
      dataPrice = "";
    }
    if (dataComparePrice === null || variantDiscount === 0) {
      dataComparePrice = "";
    }

    // Build HTML string

    let html = "";
    html += `<span class="price-item" data-variant-id="${variantId}">${dataPrice}</span><span class="price-item price-item--regular" data-variant-id="${variantId}">${dataComparePrice}</span>`;

    // Find the nearest .card-information parent and update .price content
    let cardInformation = currentTarget.closest(".card-information");
    if (cardInformation) {
      setTimeout(() => {
        let priceElement = cardInformation.querySelector(".price.swatch-price");
        if (priceElement) {
          priceElement.innerHTML = html;
        }
      }, 750);
    }
    let getEventClass = e.currentTarget.closest(".card-information__wrapper");
    let babyElement = getEventClass.querySelector(".babylist-collection");
    if (dataBabyList && babyElement) {
      babyElement.classList.remove("hidden");
    } else {
      if (babyElement) {
        babyElement.classList.add("hidden");
      }
    }

    /* end swatch change price change */
  }

  swapImage(e, imageUrl, color) {
    if (imageUrl) {
      $(e.currentTarget)
        .closest(".card-information")
        .siblings(".card")
        .find(".aspect-ratio img:first-of-type")
        .attr("alt", color)
        .attr("srcset", imageUrl)
        .attr("src", imageUrl);
    }
  }

  changeActiveState(e, color) {
    // Select new swatch
    $(e.currentTarget).siblings().removeClass("active");
    $(e.currentTarget).addClass("active");
  }

  swapLinks(e, variantUrl, variantId) {
    $(e.currentTarget)
      .closest(".card-wrapper")
      .find(".card__link")
      .attr("href", variantUrl);
  }
}

customElements.define("product-card", ProductCard);

/* FUNCTIONS */
// init AOS
$(function () {
  AOS.init({
    duration: 1000,
    once: true,
  });
});

// Cookies
function getCookie(name) {
  var v = document.cookie.match("(^|;) ?" + name + "=([^;]*)(;|$)");
  return v ? v[2] : null;
}

function setCookie(name, value, days) {
  var d = new Date();
  d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
  document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
}

/* SLIDERS */
const announcementBarSlider = new Swiper(
  ".announcement-bar__message-container",
  {
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
  }
);

// Categories grid
const categoriesGridSlider = new Swiper(".categories-grid__container", {
  slidesPerView: 1,
  loop: true,
  spaceBetween: 20,
  centeredSlides: true,
  pagination: {
    el: ".categories-grid__container .swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    769: {
      slidesPerView: 3,
      spaceBetween: 30,
      allowTouchMove: false,
      centeredSlides: false,
    },
  },
});

$(".blog-articles-slider").each(function (idx) {
  let container = $(this).find(".blog-articles__container").get(0);
  let navNext = $(this).find(".swiper-button-next").get(0);
  let navPrev = $(this).find(".swiper-button-prev").get(0);
  new Swiper(container, {
    slidesPerView: 1.3,
    loop: true,
    spaceBetween: 20,
    centeredSlides: true,
    breakpoints: {
      480: {
        watchOverflow: true,
        navigation: {
          nextEl: navNext,
          prevEl: navPrev,
        },
      },
      769: {
        slidesPerView: 1.8,
        spaceBetween: 40,
        watchOverflow: true,
        navigation: {
          nextEl: navNext,
          prevEl: navPrev,
        },
      },
      900: {
        slidesPerView: 5,
        spaceBetween: 20,
        watchOverflow: true,
        navigation: {
          nextEl: navNext,
          prevEl: navPrev,
        },
      },
    },
  });
});

// Product slider
/* const productSlider = new Swiper('.product-slider__container', {
  slidesPerView: 1.13,
  loop: true,
  spaceBetween: 20,
  breakpoints: {
    769: {
      slidesPerView: 3,
      spaceBetween: 40,
      allowTouchMove: false,
      watchOverflow: true,
      navigation: {
        nextEl: '.product-slider .swiper-button-next',
        prevEl: '.product-slider .swiper-button-prev',
      }
    }
  }
}); */
$(".product-slider").each(function (idx) {
  let container = $(this).find(".product-slider__container").get(0);
  let navNext = $(this).find(".swiper-button-next").get(0);
  let navPrev = $(this).find(".swiper-button-prev").get(0);
  new Swiper(container, {
    slidesPerView: 1.13,
    loop: true,
    spaceBetween: 20,
    breakpoints: {
      769: {
        slidesPerView: 3,
        spaceBetween: 30,
        allowTouchMove: false,
        watchOverflow: true,
        navigation: {
          nextEl: navNext,
          prevEl: navPrev,
        },
      },
    },
  });
});

// swatches add to cart
$(".freeswatch__atc").click(function () {
  const body = JSON.stringify({
    items: [
      {
        id: 39323953266842,
        quantity: 1,
      },
    ],
    sections: getSectionsToRender().map((section) => section.section),
    sections_url: window.location.pathname,
  });

  document
    .querySelector(".discount-announcements-heading")
    ?.classList.add("hidden");
  document
    .querySelector(".discount-announcements-heading-discount-applied")
    ?.classList.add("hidden");
  document
    .querySelector(".discount-announcements-heading-updating-discounts")
    ?.classList.remove("hidden");

  fetch(`${routes.cart_add_url}`, { ...fetchConfig("javascript"), body })
    .then((response) => response.json())
    .then((parsedState) => {
      getSectionsToRender().forEach((section) => {
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) ||
          document.getElementById(section.id);

        elementToReplace.innerHTML = getSectionInnerHTML(
          parsedState.sections[section.section],
          section.selector
        );
      });
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      document.querySelector("cart-drawer").open();
      typeof window.updateDiscountAnnouncements === "function" &&
        window.updateDiscountAnnouncements();
      window.updateFreeShippingBar();
    });
});

$(".freeswatch__atc_new").click(function () {
  const body = JSON.stringify({
    items: [
      {
        id: 46315281875203,
        quantity: 1,
      },
    ],
    sections: getSectionsToRender().map((section) => section.section),
    sections_url: window.location.pathname,
  });

  document
    .querySelector(".discount-announcements-heading")
    ?.classList.add("hidden");
  document
    .querySelector(".discount-announcements-heading-discount-applied")
    ?.classList.add("hidden");
  document
    .querySelector(".discount-announcements-heading-updating-discounts")
    ?.classList.remove("hidden");

  fetch(`${routes.cart_add_url}`, { ...fetchConfig("javascript"), body })
    .then((response) => response.json())
    .then((parsedState) => {
      getSectionsToRender().forEach((section) => {
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) ||
          document.getElementById(section.id);

        elementToReplace.innerHTML = getSectionInnerHTML(
          parsedState.sections[section.section],
          section.selector
        );
      });
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      document.querySelector("cart-drawer").open();
      typeof window.updateDiscountAnnouncements === "function" &&
        window.updateDiscountAnnouncements();
      window.updateFreeShippingBar();
    });
});

// Upgrade Add to cart
$(".upgrade-swatch").click(function () {
  $(this).parent().find(".upgrade-swatch").removeClass("selectedColor");
  $(this).addClass("selectedColor");
});

function getSectionsToRender() {
  return [
    {
      id: "cart-drawer__content",
      section: document.getElementById("cart-drawer__content").dataset.id,
      selector: ".cart-drawer__content",
    },
    {
      id: "cart-icon-bubble",
      section: "cart-icon-bubble",
      selector: ".shopify-section",
    },
  ];
}

function getSectionInnerHTML(html, selector) {
  return new DOMParser()
    .parseFromString(html, "text/html")
    .querySelector(selector).innerHTML;
}

$(document).ready(function () {
  var maxHeight = 0;

  $(".upgrade-product").each(function () {
    if ($(this).height() > maxHeight) {
      maxHeight = $(this).height();
    }
  });

  $(".upgrade-product").height(maxHeight);
});

// upgrade product images
$(".hover-swatch").click(function () {
  let id = $(this).data("index");
  let name = $(this).data("name");
  $(this)
    .parent()
    .parent()
    .parent()
    .parent()
    .parent()
    .parent()
    .parent()
    .find(".hover-img")
    .hide();
  $(this)
    .parent()
    .parent()
    .parent()
    .parent()
    .parent()
    .parent()
    .parent()
    .find(`.hover-img[data-index='${id}']`)
    .show();
  $(this)
    .parent()
    .parent()
    .find(`.product-form__variant-active p`)
    .text(`${name}`);
});

// Click event for any anchor tag that's href starts with #
$('a[href^="#"]').click(function (event) {
  // The id of the section we want to go to.
  if ($(this).closest(".product-variant-options")) return;

  var id = $(this).attr("href");

  // An offset to push the content down from the top.
  var offset = 60;

  // Our scroll target : the top position of the
  // section that has the id referenced by our href.
  var target = $(id).offset().top - offset;

  // The magic...smooth scrollin' goodness.
  $("html, body").animate({ scrollTop: target }, 500);

  //prevent the page from jumping down to our section.
  event.preventDefault();
});

// count up function
if ($(".product-features__count").length) {
  var observer = new IntersectionObserver(
    function (entries) {
      if (entries[0].isIntersecting === true)
        $(".countUp").each(function () {
          var $this = $(this),
            countTo = $this.attr("data-count");

          $({ countNum: $this.text() }).animate(
            {
              countNum: countTo,
            },

            {
              duration: 5000,
              easing: "linear",
              step: function () {
                $this.text(Math.floor(this.countNum));
              },
              complete: function () {
                $this.text(this.countNum);
              },
            }
          );
        });
    },
    { threshold: [1] }
  );

  observer.observe(document.querySelector(".product-features__count"));
}

jQuery(document).ready(function ($) {
  var hash = window.location.hash;
  if (hash == "" || hash == "#" || hash == undefined) return false;
  var target = $(hash);
  headerHeight = 120;
  target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
  if (target.length) {
    $("html,body")
      .stop()
      .animate(
        {
          scrollTop: target.offset().top - 150, //offsets for fixed header
        },
        "linear"
      );
  }
});

Shopify.money_format = Shopify?.money_format || "${{amount}}";
Shopify.formatMoney =
  Shopify.formatMoney ||
  function (cents, format) {
    if (typeof cents == "string") {
      cents = cents.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || this.money_format;

    function defaultOption(opt, def) {
      return typeof opt == "undefined" ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ",");
      decimal = defaultOption(decimal, ".");

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split("."),
        dollars = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          "$1" + thousands
        ),
        cents = parts[1] ? decimal + parts[1] : "";

      return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };

document.querySelectorAll(".product-variant-options").forEach((variant) => {
  variant
    .querySelectorAll(".tabs-stage-variant .tab-content")
    .forEach((tab, index) => {
      if (index === 0) tab.classList.add("tab-active");
    });
  variant
    .querySelectorAll(".tabs-nav-variant li")[0]
    ?.classList.add("tab-active");

  variant.querySelectorAll(".tabs-nav-variant li").forEach((anchor) => {
    anchor.addEventListener("click", function (event) {
      event.preventDefault();
      variant.querySelectorAll(".tabs-nav-variant li").forEach((tab) => {
        tab.classList.remove("tab-active");
      });
      this.querySelector("a").parentElement.classList.add("tab-active");
      variant
        .querySelectorAll(".tabs-stage-variant .tab-content")
        .forEach((tabContent) => {
          tabContent.classList.remove("tab-active");
        });
      variant
        .querySelector(this.querySelector("a").getAttribute("href"))
        .classList.add("tab-active");

      let fieldsetsTab = variant.querySelectorAll(
        ".tab-content.tab-active fieldset"
      );
      fieldsetsTab.forEach((fieldset) => {
        const firstInput = fieldset.querySelector("input");
        firstInput.click();
      });
      this.addEventListener("click", updateSelectedValues(event));
    });
  });
});

const variantInputs = document.querySelectorAll(
  ".main-product-box-wrapper .variant-value"
);
variantInputs.forEach((input) => {
  input.addEventListener("click", updateSelectedValues);
});

let productFields = document.querySelectorAll(".main-product-box-wrapper");
productFields.forEach((productField) => {
  productField.addEventListener("mouseleave", () => {
    const firstFieldset = productField.querySelectorAll(
      ".tab-content.tab-active fieldset"
    );
    firstFieldset.forEach((variantField) => {
      const firstVariant = variantField.querySelector(".variant-value");
      const defaultHoverImage = productField.getAttribute("data-hover-image");
      if (firstVariant) {
        firstVariant.querySelector("label").click();
      }
      if (defaultHoverImage && productHoverImage) {
        const productHoverImage = productField.querySelector(
          "img.block-product-image-hover"
        );
        productHoverImage.src = defaultHoverImage;

        productHoverImage.srcset = `
          ${defaultHoverImage}?crop=center&height=188&width=187 187w,
          ${defaultHoverImage}?crop=center&height=377&width=375 375w,
          ${defaultHoverImage}?crop=center&height=416&width=414 414w,
          ${defaultHoverImage}?crop=center&height=680&width=676 676w,
          ${defaultHoverImage}?crop=center&height=735&width=730 730w
        `;
        productHoverImage.sizes = "100vw";
      }
    });
  });
});

function updateSelectedValues(event) {
  const selectedTab = event.target.closest(".tabs-nav-variant");
  const variantOptions = event.target.closest(".main-product-images");
  const variantOptionsMain = event.target.closest(".main-product-box-wrapper");
  const productMainLink = event.target
    .closest(".main-product-box-wrapper")
    .querySelectorAll("a.product-link");
  const productMainTitle = event.target
    .closest(".main-product-box-wrapper")
    .querySelector(".heading.product-title");
  const productContent = event.target
    .closest(".main-product-box-wrapper")
    .querySelector(".product-price-container");
  const defaultProductImage = variantOptions.getAttribute("data-image");
  const variantOptionsSelect = variantOptions.querySelector(
    ".tab-content.tab-active .variant-options-product"
  );
  const productHoverImage = variantOptions.querySelector(
    "img.block-product-image-hover"
  );
  const productMainImage = variantOptions.querySelector("img.product-image");
  const productMainImageSection = variantOptions.querySelector(
    "img.main-product-image"
  );
  const productBlockMainImage = variantOptions.querySelector(
    "img.block-product-image"
  );
  const fieldsets = variantOptions.querySelectorAll(
    ".tab-content.tab-active fieldset"
  );
  let selectedValues = [];

  productHoverImage?.classList.remove("force-zoom");
  productMainImage?.classList.remove("persist-zoom");
  productBlockMainImage?.classList.remove("persist-zoom");
  productMainImageSection?.classList.remove("persist-zoom");

  if (!selectedTab) {
    const clickVariant = event.target.classList.contains("variant-value")
      ? event.target.querySelector("input").value
      : event.target.closest(".variant-value").querySelector("input").value;
    event.target.closest("fieldset").querySelector(".form-label").textContent =
      clickVariant;
    const allInputFields = event.target
      .closest("fieldset")
      .querySelectorAll("input");
    allInputFields.forEach((input) => {
      input.removeAttribute("checked");
    });
    event.target
      .closest(".variant-value")
      .querySelector("input")
      .setAttribute("checked", true);
  }

  fieldsets.forEach((fieldset) => {
    const checkedInput = fieldset.querySelector("input:checked");
    if (checkedInput) {
      selectedValues.push(checkedInput.value);
    }
  });

  const selectedValuesString = selectedValues.join(" / ");
  const variantListItems = variantOptionsSelect.querySelectorAll("li");

  variantListItems.forEach((item) => {
    const itemValue = item.getAttribute("variantTitle");

    if (selectedValuesString == itemValue) {
      const productTitle = item.getAttribute("productTitle");
      const productLink = item.getAttribute("productLink");
      const variantHoverImage = item.getAttribute("variantHoverImage");
      const variantPrice = item.getAttribute("variantPrice");
      const variantComparePrice = item.getAttribute("varinatComparePrice");
      const variantDiscount = item.getAttribute("variantDiscount");
      const variantId = item.getAttribute("variantId");

      if (productTitle) {
        productMainTitle.innerHTML = productTitle;
      }

      if (productLink) {
        productMainLink.forEach((link) => {
          link.href = productLink;
        });
      }

      if (variantComparePrice >= variantPrice) {
        productContent.querySelector(".price").classList.add("price--on-sale");
        if (
          productContent.querySelector(
            ".price__sale .price__compare .price-item--regular"
          )
        ) {
          productContent
            .querySelector(".price__sale .price__compare .price-item--regular")
            .setAttribute("data-variant-id", variantId);
          productContent.querySelector(
            ".price__sale .price__compare .price-item--regular"
          ).innerHTML = variantComparePrice;
        }
      } else {
        productContent
          .querySelector(".price")
          .classList.remove("price--on-sale");
      }

      if (variantDiscount) {
        variantOptionsMain
          .querySelectorAll(".product-discount-tag")
          .forEach((discounrTag) => {
            discounrTag.innerHTML = "$" + variantDiscount + " OFF";
            discounrTag.classList.remove("hidden");
          });
      } else {
        variantOptionsMain
          .querySelectorAll(".product-discount-tag")
          .forEach((discounrTag) => {
            discounrTag.classList.add("hidden");
          });
      }

      if (
        productContent.querySelector(".price__regular .price-item--regular")
      ) {
        productContent
          .querySelector(".price__regular .price-item--regular")
          .setAttribute("data-variant-id", variantId);
        if (variantDiscount && variantDiscount > 0) {
          productContent
            .querySelector(".price__regular .price-item--regular")
            .setAttribute("data-price-offset", `-${variantDiscount}`);
        }
        productContent.querySelector(
          ".price__regular .price-item--regular"
        ).innerHTML = variantPrice;
      }
      if (productContent.querySelector(".price__sale .price-item--sale")) {
        productContent
          .querySelector(".price__sale .price-item--sale")
          .setAttribute("data-variant-id", variantId);
        if (variantDiscount && variantDiscount > 0) {
          productContent
            .querySelector(".price__sale .price-item--sale")
            .setAttribute("data-price-offset", `-${variantDiscount}`);
        }
        productContent.querySelector(
          ".price__sale .price-item--sale"
        ).innerHTML = variantPrice;
      }

      if (variantHoverImage && productHoverImage) {
        if (variantHoverImage.includes("no-image-")) {
          productHoverImage.src = defaultProductImage;
          productHoverImage.srcset = `
            ${defaultProductImage}?crop=center&height=188&width=187 187w,
            ${defaultProductImage}?crop=center&height=377&width=375 375w,
            ${defaultProductImage}?crop=center&height=416&width=414 414w,
            ${defaultProductImage}?crop=center&height=680&width=676 676w,
            ${defaultProductImage}?crop=center&height=735&width=730 730w
          `;
        } else {
          productHoverImage.src = variantHoverImage;
          productHoverImage.srcset = `
            ${variantHoverImage}?crop=center&height=188&width=187 187w,
            ${variantHoverImage}?crop=center&height=377&width=375 375w,
            ${variantHoverImage}?crop=center&height=416&width=414 414w,
            ${variantHoverImage}?crop=center&height=680&width=676 676w,
            ${variantHoverImage}?crop=center&height=735&width=730 730w
          `;
        }
      }
    }
  });
}

document.addEventListener("click", function (event) {
  const flyOutContainer = document.querySelector(".fly-out-cards-container");
  const cartDrawer = document.querySelector("#cart-drawer");
  const cartIconBubble = document.querySelector("#cart-icon-bubble");
  const cartDrawerClose = document.querySelector("#cart-drawer__close");
  const pageOverlay = document.querySelector(".page-overlay");

  if (pageOverlay && pageOverlay.classList.contains("is-visible")) {
    if (
      flyOutContainer &&
      !flyOutContainer.contains(event.target) &&
      cartDrawer &&
      !cartDrawer.contains(event.target) &&
      cartIconBubble &&
      !cartIconBubble.contains(event.target)
    ) {
      cartDrawerClose.click();
    }
  }
});

document.querySelectorAll(".custom-show-filter").forEach(function (button) {
  button.addEventListener("click", function () {
    this.closest(".collection-list-new").classList.add("custom-filter-enable");
  });
});

document.querySelectorAll(".custom-hide-filter").forEach(function (button) {
  button.addEventListener("click", function () {
    this.closest(".collection-list-new").classList.remove(
      "custom-filter-enable"
    );
  });
});

document.querySelectorAll(".back-to-top").length > 0 &&
  document.querySelectorAll(".back-to-top").forEach((button) => {
    button.addEventListener("click", () => {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    });
  });


  const observerChat = new MutationObserver(() => {
    const chatButton = document.querySelector('#chat-button');
    if (chatButton) {
      chatButton.setAttribute('aria-label', 'Chat with us');
      chatButton.setAttribute('tabindex', '0');
      observerChat.disconnect();
    }
  });
  
  observerChat.observe(document.body, { childList: true, subtree: true });

  function onKeyUpEscape(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
  
    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;
  
    const summaryElement = openDetailsElement.querySelector('summary');
    openDetailsElement.removeAttribute('open');
    summaryElement.setAttribute('aria-expanded', false);
    summaryElement.focus();
  }


  document.addEventListener('DOMContentLoaded', function () {
    function updateModalPosition() {
      const headerHeight = document.querySelector('.sticky-header').offsetHeight;
  
      const modal = document.querySelector('.addon-accordians-block .product-popup-modal');
      if (modal) {
        modal.style.top = `${headerHeight}px`;
        modal.style.height = `calc(100% - ${headerHeight}px)`;
      }
  
      const dynamicStyles = `
        .addon-accordians-block .product-popup-modal:after {
          top: ${headerHeight}px;
          height: calc(100% - ${headerHeight}px);
        }
      `;
  
      const existingStyle = document.getElementById('dynamic-styles');
      if (existingStyle) {
        existingStyle.remove();
      }
  
      const styleElement = document.createElement('style');
      styleElement.id = 'dynamic-styles';
      styleElement.textContent = dynamicStyles;
      document.head.appendChild(styleElement);
    }
  
    updateModalPosition();
    window.addEventListener('resize', updateModalPosition);
    window.addEventListener('scroll', updateModalPosition);
  });

  const videosCollection = document.querySelectorAll('.collection-meta-video video');
  const playButtonsCollection = document.querySelectorAll('.collection-meta-video .video-icon');
  if(playButtonsCollection){
    playButtonsCollection.forEach((button) => {
      button.onclick = function (event) {
        const video = this.closest('.video-with-text').querySelector('video');
        if (video.paused) {
          videosCollection.forEach(item => {
            item.pause();
            item.closest('.video-with-text').classList.remove('active');
          });
          video.play();
          video.closest('.video-with-text').classList.add('active');
        } else {
          video.pause();
          video.closest('.video-with-text').classList.remove('active');
        }
      }
    });
  }   